export const styles = {
  container: {
    height: 400,
    width: '100%',
    boxSizing: 'border-box',
    px: 2,
    py: 1.5,
  },
};
